/**
 * Created by senani on 12/21/18.
 */

import React, {Component, Fragment} from "react";
import {Link, Redirect} from "react-router-dom";
import "./PriceInformation.css";
import {FormattedMessage} from "react-intl";
import ShippingEstimate from './ShippingEstimate/ShippingEstimate';
import axios from 'axios';
import {BASE_URL, IS_IN_MOBILE_MODE, RESOURCE_BASE_URL} from "../../../configuration";
import NumberFormatter from "../../Common/NumberFormatter/NumberFormatter";
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import PriceLoadingImage from "../../../assets/img/loading_price.gif";
import ReactTooltip from 'react-tooltip';
import Modal from "react-bootstrap/es/Modal";


let InitialOrderItemJson = {
    cartId: "-1",
    itemName: "",
    unitPrice: 0.00,
    quantity: 1,
    chargeDetails: {
        buildTime: "N/A",
        shippingEstimate: "N/A",
        totalPrice: 0.00,
        weight: 0,
        priceInfoJson: "N/A",
        totalCostJlcpcb: 0.00
    },
    quotation: {
        orderType: -1,
        gerberFilePath: "N/A",
        imagePath: "N/A",
        fileKey: "N/A",
        pcbParamJson: "N/A",
        pcbParam: {},
        stencilParam: {}
    },
    gerberDto: {
        id: "-1",
        originalFileName: "N/A",
        fileUrl: "N/A",
        imageUrl: "N/A",
        key: "N/A",
        imageUrlTop: "N/A",
        imageUrlBottom: "N/A",
        layers: 2,
        width: 1,
        length: 1,
        jlcpcbGerberReviewResultDto: null
    },
    totalAmount: 0,
    taxAmount: 0,
    reviewResult: true,
    edgeRails: 0
};

const PricingPanel = (props) => {
    return (
        <div className="price-info">
            <div className="row responsive-pricing-row">
                <div className="col-md-8 custom-col-8">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.initial-fee"
                                          defaultMessage="Initial Fee"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text pull-right">
                        &#165; <NumberFormatter num={props.initialFee}/>
                    </p>
                </div>
            </div>
            <div className="row responsive-pricing-row">
                <div className="col-md-8 custom-col-8">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.manufacturing-cost"
                                          defaultMessage="Substrate Manufacturing Cost"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text pull-right">
                        &#165; <NumberFormatter num={props.manufacturingCost}/>
                    </p>
                </div>
                <div className="col-md-12" id="build-time-price-div">
                    <li>
                        <FormattedMessage id="app.price.info.build.time"
                                          defaultMessage="Production time"
                                          description=""
                        />
                        {props.orderBuildTime}
                    </li>
                </div>
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text pull-right">
                        {/*&#165; 12,300/!*<NumberFormatter num="12,300"/>*!/*/}
                    </p>
                </div>
            </div>

            <div className="row responsive-pricing-row">
                <div className="col-md-8 custom-col-8">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.metal-mask"
                                          defaultMessage="Metal Mask"
                                          description=""
                        />

                    </p>
                </div>
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text pull-right">
                        &#165; <NumberFormatter num={props.metalMaskCost}/>
                    </p>
                </div>
            </div>
            <div className="row responsive-pricing-row">
                <div className="col-md-4 custom-col-4">
                    &nbsp;
                </div>
            </div>
            <div className="row responsive-pricing-row">
                <div className="col-md-8 custom-col-8">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.discount"
                                          defaultMessage="Discount"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text pull-right">
                        &#165; <NumberFormatter num={props.discount}/>
                    </p>
                </div>
            </div>

            <div className="row responsive-pricing-row">
                <div className="col-md-12">
                    <hr className="quotation-summary-hr"/>
                </div>
            </div>

            <div className="row responsive-pricing-row">
                <div className="col-md-8 custom-col-8">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.sub-total"
                                          defaultMessage="Subtotal"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text pull-right">
                        &#165; <NumberFormatter num={props.subtotal}/>
                    </p>
                </div>
            </div>
            <div className="row responsive-pricing-row">
                <div className="col-md-8 custom-col-8">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.consumption-tax"
                                          defaultMessage="Consumption Tax"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text pull-right">
                        &#165; <NumberFormatter num={props.tax}/>
                    </p>
                </div>
            </div>
            <hr className="quotation-summary-hr"/>
            <div className="row total-price-separator responsive-pricing-row">
                <div className="col-md-4 custom-col-4 no-padding">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.total"
                                          defaultMessage="Total"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-8 custom-col-8 no-padding">
                    <p className="price-info-static-text price-info-total-text">
                        &#165; <NumberFormatter num={props.total}/>
                    </p>
                </div>
            </div>
            <hr className="quotation-summary-hr"/>
            <div className="row responsive-pricing-row">
                <div className="col-md-6 custom-col-6">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.quotation.price-info.shipping"
                                          defaultMessage="Shipping"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-6 custom-col-6">
                    <p className="price-info-static-text pull-right">
                        <FormattedMessage id="app.quotation.price-info.shipping-sagawa"
                                          defaultMessage="SGX (SAGAWA)"
                                          description=""
                        />

                    </p>
                </div>
            </div>
            <div className="row responsive-pricing-row">
                <div className="col-md-4 custom-col-4">
                    <p className="price-info-static-text">
                        <FormattedMessage id="app.price.info.delivery.time.period"
                                          defaultMessage="Delivery Time"
                                          description=""
                        />
                    </p>
                </div>
                <div className="col-md-8 custom-col-8 padding-remove-left-priceInf">

                    <p className="price-info-static-text pull-right">
                        <li>
                            製造時間に＋3日を目安。
                        </li>
                    </p>

                </div>
            </div>

            <hr className="quotation-summary-hr"/>
            <div className="spaceH"></div>

            <div className="row price-msg-div responsive-pricing-row">

                                    <span className="price-msg-span">&#8251;<FormattedMessage
                                        id="app.quotation.price-div.msg-1"
                                        defaultMessage="国際配送便のため、到着予定日中の到着となります。"
                                        description=""/></span><br/>
                <span className="price-msg-span">&#8251;<FormattedMessage
                    id="app.quotation.price-div.msg-29"
                    defaultMessage="お届け予定は運送会社様の事情、交通、事情、気象事情等に"
                    description=""/>
                                    <font className="price-msg-span-size01">より予定日にお届けできない場合がございます。</font></span><br/>
                <span className="price-msg-span">&#8251;<FormattedMessage
                    id="app.quotation.price-div.msg-39"
                    defaultMessage="到着日が土曜日、日曜日及び祝祭日の商品に関しましては、"
                    description=""/>
                                    <font className="price-msg-span-size02">場合により到着予定日にお届けできない事がございます</font></span><br/>
                <span className="price-msg-span">&#8251;<FormattedMessage
                    id="app.quotation.price-div.msg-49"
                    defaultMessage="基板製造費に、輸入申告諸費用（関税、国内外送料）全て含"
                    description=""/>
                                    <font className="price-msg-span-size03">まれています。お客様にて荷物を受け取る際に別途お支払い</font>
                                    <font className="price-msg-span-size04">頂く必要はございません。</font><br/>
                                    <font className="price-msg-span-size05">※離島エリアへ配送する場合、別請求の「離島中継手数料」が掛かります。（ご注文金額が￥10,000-を超える場合は、離島中継手数料は無料になります）</font></span><br/>
            </div>
        </div>
    );
};

const AddToCartToggle = (props) => {
    if (InitialQuotationState.cartItemEditMode) {
        return (
            <Fragment>
                <button onClick={props.editCartItem} className="btn add-to-cart-btn">
                    <FormattedMessage id="app.price.info.add.to.cartEdit"
                                      defaultMessage="Edit Item"
                                      description=""/>
                </button>
                <div onClick={props.editCartItem} className="responsive-add-to-cart">
                    <FormattedMessage id="app.price.info.add.to.cartEdit"
                                      defaultMessage="Edit Item"
                                      description=""/>
                </div>
            </Fragment>
        )
    } else {
        if (localStorage.getItem("stencilOnly") === "y") {
            localStorage.removeItem("stencilOnly");
            return (
                <div>
                {localStorage.getItem("userRole") !== "ROLE_IMPERSONATE" ?
                <Fragment>
                        <button onClick={props.addToCart} className="btn add-to-cart-btn">
                            <FormattedMessage id="app.price.info.add.to.cart"
                                              defaultMessage="Add To Cart"
                                              description=""/>
                        </button>
                        <button onClick={props.addToCart} className="responsive-add-to-cart">
                            <FormattedMessage id="app.price.info.add.to.cart"
                                              defaultMessage="Add To Cart"
                                              description=""/>
                        </button>
                </Fragment> :
                        <Fragment>
                            <button onClick={props.addToCart} disabled={true} className="btn add-to-cart-btn">
                                <FormattedMessage id="app.price.info.add.to.cart"
                                                  defaultMessage="Add To Cart"
                                                  description=""/>
                            </button>
                            <button onClick={props.addToCart} disabled={true} className="responsive-add-to-cart">
                                <FormattedMessage id="app.price.info.add.to.cart"
                                                  defaultMessage="Add To Cart"
                                                  description=""/>
                            </button>
                        </Fragment> }
                </div>
            )
        } else if (props.gerberImageData.id === -1 || props.errorMessage !== null || props.selectedLength < 6 || props.selectedWidth < 6) {
            return (
                <Fragment>
                    <button data-tip="React-tooltip" disabled={true} className=" tooltip btn add-to-cart-btn">
                        <FormattedMessage id="app.price.info.add.to.cart"
                                          defaultMessage="Add To Cart"
                                          description=""/>
                        <span className="tooltiptext">ガーバーファイルをアップロードしてください。</span>
                    </button>
                    <ReactTooltip place="top" type="dark" effect="solid"/>
                    <button onClick={() => props.showGerberUploadModal(true)}
                            className="responsive-add-to-cart responsive-add-to-cart-disabled">
                        <FormattedMessage id="app.price.info.add.to.cart"
                                          defaultMessage="Add To Cart"
                                          description=""/>
                    </button>
                </Fragment>
            )
        } else {
            return (
                <div>
                    {localStorage.getItem("userRole") !== "ROLE_IMPERSONATE" ?
                <Fragment>
                    <button onClick={props.addToCart} className="btn add-to-cart-btn">
                        <FormattedMessage id="app.price.info.add.to.cart"
                                          defaultMessage="Add To Cart"
                                          description=""/>
                    </button>
                    <button onClick={props.addToCart} className="responsive-add-to-cart">
                        <FormattedMessage id="app.price.info.add.to.cart"
                                          defaultMessage="Add To Cart"
                                          description=""/>
                    </button>
                </Fragment> :
                        <Fragment>
                            <button onClick={props.addToCart} disabled={true} className="btn add-to-cart-btn">
                                <FormattedMessage id="app.price.info.add.to.cart"
                                                  defaultMessage="Add To Cart"
                                                  description=""/>
                            </button>
                            <button onClick={props.addToCart} disabled={true} className="responsive-add-to-cart">
                                <FormattedMessage id="app.price.info.add.to.cart"
                                                  defaultMessage="Add To Cart"
                                                  description=""/>
                            </button>
                        </Fragment>}
                </div>
            )
        }
    }
};

let overlayHeight = 0;
let priceLoadingViewResponsive = 'price-loading-view-responsive-none';

class PriceInformation extends Component {


    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.userId,
            redirect: false,
            itemId: "",
            manufactureTime: '',
            addToCartFailShow: false,
            showPricingModal: this.props.showPricingModal,
            calculatedBuildTime: '24時間',
            showGerberUploadModal: false
        };

        this.addToCart = this.addToCart.bind(this);
        this.createOrderJson = this.createOrderJson.bind(this);
        this.gerberImageData = this.gerberImageData.bind(this);
        this.editCartItem = this.editCartItem.bind(this);
        this.getJapaneseDateFormat = this.getJapaneseDateFormat.bind(this);
        this.loadingOn = this.loadingOn.bind(this);
        this.loadingOff = this.loadingOff.bind(this);
        this.addToCartFailedHandleShow = this.addToCartFailedHandleShow.bind(this);
        this.addToCartFailedHandleClose = this.addToCartFailedHandleClose.bind(this);
        this.showGerberUploadModal = this.showGerberUploadModal.bind(this);

    }

    showGerberUploadModal = (status) => {
        this.setState({
            showGerberUploadModal: status
        })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.showPricingModal) {
            let summary = document.getElementsByClassName("summary-fixed-z")[0];
            let pricing = document.getElementsByClassName("pricing-fixed-z")[0];
            pricing.classList.replace("pricing-fixed-z", "pricing-fixed");
            summary.classList.replace("summary-fixed-z", "summary-fixed");
        } else {
            let summary = document.getElementsByClassName("summary-fixed")[0];
            let pricing = document.getElementsByClassName("pricing-fixed")[0];

            if (summary !== undefined) {
                summary.classList.replace("summary-fixed", "summary-fixed-z");
            }
            if (pricing !== undefined) {
                pricing.classList.replace("pricing-fixed", "pricing-fixed-z");
            }
        }
        if (prevProps.userData !== this.props.userData && this.props.userData
            && this.props.userId) {
            this.setState({userId: this.props.userId});
        }

        if (this.props.loadingPrice === true) {
            this.loadingOn();
        } else {
            this.loadingOff();
        }
        let ele = document.getElementsByClassName('price-information-div');
        overlayHeight = ele[0].clientHeight + 2;

        let buildTimeJson = {
            orderType: this.props.quotation.orderType,
            layer: this.props.quotation.pcbParam.layer,
            pcbColor: this.props.quotation.pcbParam.pcbColor,
            qty: this.props.quotation.pcbParam.qty,
            thickness: this.props.quotation.pcbParam.thickness
        };
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        let cartEditResourceUrl = RESOURCE_BASE_URL + 'api/jlcpcb/buildTime';
        axios.post(cartEditResourceUrl, buildTimeJson, axiosConfig)
            .then((res) => {
                // this.calTime = res.data;

                if (this.state.calculatedBuildTime !== res.data) {
                    this.setState({
                        calculatedBuildTime: res.data
                    })
                }
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });


    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        let ele = document.getElementsByClassName('price-information-div');
        overlayHeight = ele[0].clientHeight + 2;
    }

    componentDidMount() {
        this.setState({
            itemId: this.props.itemId
        });
        let ele = document.getElementsByClassName('price-information-div');
        overlayHeight = ele[0].clientHeight + 2;
        // this.setState({
        //     priceLoadingViewResponsive: "price-loading-view-responsive-none"
        //
        // })
        console.log("this.props.userData =============> ", localStorage.getItem("userId"));
        priceLoadingViewResponsive = 'price-loading-view-responsive-none';
    }


    addToCartFailedHandleClose = () => {
        this.setState({
            addToCartFailShow: false,
            redirectOnFail: true
        })
    };

    addToCartFailedHandleShow = () => {
        this.setState({
            addToCartFailShow: true
        })
    };

    createOrderJson = (orderItemJson) => {

        orderItemJson.itemName = this.props.gerberImageData.originalFileName;
        orderItemJson.unitPrice = this.props.mainPriceInformation.total;
        orderItemJson.quotation.orderType = this.props.quotation.orderType;
        orderItemJson.chargeDetails = {
            buildTime: "3-5 days", // TODO
            shippingEstimate: this.props.mainPriceInformation.shippingDate, // TODO
            totalPrice: this.props.mainPriceInformation.total,
            weight: this.props.mainPriceInformation.weight
        };

        orderItemJson.quotation.pcbParam = this.props.quotation.pcbParam;
        orderItemJson.quotation.stencilParam = this.props.quotation.smtStencilParam;

        switch (this.props.quotation.orderType) {
            case 1:
                orderItemJson.quotation.pcbParamJson = JSON.stringify(this.props.quotation.pcbParam);
                break;
            case 2:
                orderItemJson.quotation.pcbParamJson = JSON.stringify({
                    pcbParam: this.props.quotation.pcbParam,
                    smtStencilParam: this.props.quotation.smtStencilParam
                });
                break;
            case 3:
                orderItemJson.quotation.pcbParamJson = JSON.stringify(this.props.quotation.smtStencilParam);
                break;
            default:
                break;
        }
    };

    gerberImageData = (orderItemJson) => {

        let gerberImageData = {...InitialQuotationState.gerberImageData};
        // console.log("GERBER INITIAL DUO ====> ", gerberImageData);
        orderItemJson.quotation.gerberFilePath = gerberImageData.fileUrl;
        orderItemJson.quotation.imagePath = gerberImageData.imageUrlTop;
        orderItemJson.quotation.fileKey = gerberImageData.key;

        orderItemJson.gerberDto.fileUrl = gerberImageData.fileUrl;
        orderItemJson.gerberDto.id = "-1";
        orderItemJson.gerberDto.imageUrl = gerberImageData.imageUrl;
        orderItemJson.gerberDto.imageUrlBottom = gerberImageData.imageUrlBottom;
        orderItemJson.gerberDto.imageUrlTop = gerberImageData.imageUrlTop;
        orderItemJson.gerberDto.jlcpcbGerberReviewResultDto = gerberImageData.jlcpcbGerberReviewResultDto;
        orderItemJson.gerberDto.key = gerberImageData.key;
        orderItemJson.gerberDto.layers = this.props.quotation.pcbParam.layer;
        orderItemJson.gerberDto.width = this.props.quotation.pcbParam.width;
        orderItemJson.gerberDto.length = this.props.quotation.pcbParam.length;
        orderItemJson.gerberDto.originalFileName = gerberImageData.originalFileName;


    };

    editCartItem = () => {

        this.props.turnOnOverlay();
        let quotation = this.props.quotation;
        let type = this.props.quotation.orderType;

        let params = {};

        if (type === 1 || type === 2) {
            params = {
                "country": "jp",
                "orderType": type,
                "pcbParam": quotation.pcbParam,
                "shippingMethod": "dhl",
                "smtStencilParam": quotation.smtStencilParam
            }
        } else if (type === 3) {
            params = {
                "country": "jp",
                "orderType": type,
                "shippingMethod": "dhl",
                "smtStencilParam": quotation.smtStencilParam
            }
        } else {
        }

        let editCartItemJson = {
            pricingRequest: params,
            totalAmount: this.props.mainPriceInformation.total,
            taxAmount: this.props.mainPriceInformation.consumptionTax,
            priceInfo: this.props.mainPriceInformation
        };

        let editItemId = InitialQuotationState.editCartItemId;

        if (localStorage.getItem("logStatus") === "logged" && this.props.userData !== null && editItemId !== null) {

            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            };

            let cartEditResourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.state.userId + '/cart/item/edit/' + editItemId;

            axios.put(cartEditResourceUrl, editCartItemJson, axiosConfig)
                .then((res) => {
                    InitialQuotationState.editCartItemId = null;
                    InitialQuotationState.cartItemEditMode = false;
                    this.props.getCartItems();
                    this.setState({redirect: true}, () => this.props.turnOffOverlay());

                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                    this.props.turnOffOverlay();
                });


        } else {
            // this.props.keycloak.login({redirectUri: BASE_URL + 'cart'});
        }
    };

    addToCartAfterLogin = () => {
        let orderItemJson = JSON.parse(localStorage.getItem("oi"));
    };

    addToCart = () => {

        this.props.turnOnOverlay();

        let gerberData = {...InitialQuotationState.gerberImageData};

        let orderItemJson = {...InitialOrderItemJson};

        if (localStorage.getItem("withoutResult") === null) {
            orderItemJson.reviewResult = true;
        } else {
            orderItemJson.reviewResult = false;
        }

        if (localStorage.getItem("edgeRails") === "y") {
            orderItemJson.edgeRails = 1;
        } else {
            orderItemJson.edgeRails = 0;
        }

        this.gerberImageData(orderItemJson);
        this.createOrderJson(orderItemJson);

        // orderItemJson.quotation.fileKey = gerberData.key;
        orderItemJson.quotation.fileKey = InitialQuotationState.gerberFileKey;
        orderItemJson.totalAmount = this.props.mainPriceInformation.total;
        orderItemJson.taxAmount = this.props.mainPriceInformation.consumptionTax;
        orderItemJson.cartId = "cart_id_duo_dummy";

        if (localStorage.getItem("logStatus") === "logged" && localStorage.getItem("userId") !== null) {
            localStorage.setItem("ci", null);
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            };

            let cartResourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.state.userId + '/cart';

            console.log("cart url ====> ", cartResourceUrl);
            console.log("ADD TO CART REQUEST DUO ====> ", orderItemJson);

            axios.post(cartResourceUrl, orderItemJson, axiosConfig)
                .then((res) => {
                    localStorage.removeItem("withoutResult");
                    localStorage.removeItem("edgeRails");
                    this.props.getCartItems();
                    this.props.turnOffOverlay();
                    this.setState({redirect: true});

                    InitialQuotationState.gerberImageData = {
                        fileUrl: "",
                        id: -1,
                        imageUrl: "",
                        imageUrlBottom: "",
                        imageUrlTop: "",
                        key: "",
                        originalFileName: ""
                    }
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                    this.props.turnOffOverlay();
                    setTimeout(this.addToCartFailedHandleClose, 4000);
                });
        } else {
            localStorage.setItem("ci", JSON.stringify(orderItemJson));
            window.location.href = BASE_URL + "login";
            // this.props.keycloak.login({redirectUri: BASE_URL + 'cart'});
        }
    };

    getJapaneseDateFormat = (date) => {
        let d = new Date(date);

        let lang = "ja";

        let year = d.toLocaleString(lang, {year: 'numeric'});
        let month = d.toLocaleString(lang, {month: 'short'});
        let day = d.toLocaleString(lang, {day: 'numeric'});

        return year + " " + month + " " + day + " ";
    };

    loadingOn = () => {

        // alert("block");
        document.getElementById("overlay").style.display = "block";
        document.getElementById("mobile-price-loading").style.display = "block";
        // if (document.getElementById("price-loading-view-responsive-block")) {
        //     // this.state.priceLoadingViewResponsive = "price-loading-view-responsive"
        //     this.setState({
        //         priceLoadingViewResponsive: "price-loading-view-responsive-none"
        //
        //     })
        // }

        // setTimeout(this.loadingOff, 3000);
    };

    loadingOff = () => {
        // if (document.getElementById("overlay") !== null) {
        //     document.getElementById("overlay").style.display = "none";
        // }
        // alert("none");

        document.getElementById("overlay").style.display = "none";
        document.getElementById("mobile-price-loading").style.display = "none";
        // if (document.getElementById("price-loading-view-responsive-none")) {
        //     this.setState({
        //         priceLoadingViewResponsive: "price-loading-view-responsive-block"
        //
        //     })
        // }


    };

    render() {
        // main parice info------------------------------------

        let initialFee = 0;
        let manufacturingCost = 0;
        let metalMaskCost = 0;
        let discount = 0;
        let subtotal = 0;
        let tax = 0;
        let total = 0;
        let shippingDate = "";
        let deliveryDate = "";
        let buildTime = "";

        if (this.props.mainPriceInformation !== null) {
            initialFee = this.props.mainPriceInformation.initialFee;
            manufacturingCost = this.props.mainPriceInformation.manufacturingCost;
            metalMaskCost = this.props.mainPriceInformation.metalMask;
            discount = this.props.mainPriceInformation.discount;
            subtotal = this.props.mainPriceInformation.subTotal;
            tax = this.props.mainPriceInformation.consumptionTax;
            total = this.props.mainPriceInformation.total;
            // shippingDate =  this.getJapaneseDateFormat(this.props.mainPriceInformation.shippingDate);
            // deliveryDate =  this.getJapaneseDateFormat(this.props.mainPriceInformation.deliveryDate);
            shippingDate = this.getJapaneseDateFormat("2019-06-30");
            deliveryDate = this.getJapaneseDateFormat("2019-07-02");
        }
        // main price info------------------------------------


        let overlaystyle = {
            height: overlayHeight

        };

        // let orderBuildTime = " 24時間";
        // let qty = this.props.quotation.pcbParam.qty;
        // let layer = this.props.quotation.pcbParam.layer;
        //
        // if (layer === 1) {
        //     if (qty <= 10) {
        //         orderBuildTime = " 24時間"
        //     } else if (qty >= 15 && qty <= 30) {
        //         orderBuildTime = " 1-2日";
        //     } else if (qty === 50) {
        //         orderBuildTime = " 3-4日";
        //     } else if (qty >= 75 && qty <= 1000) {
        //         orderBuildTime = " 4-5日"
        //     }
        // } else if (layer === 2) {
        //     if (qty <= 10) {
        //         orderBuildTime = " 24時間"
        //     } else if (qty >= 15 && qty <= 30) {
        //         orderBuildTime = " 1-2日";
        //     } else if (qty >= 50 && qty <= 1000) {
        //         orderBuildTime = " 5-6日";
        //     }
        // } else if (layer === 4) {
        //     if (qty <= 50) {
        //         orderBuildTime = " 4-5日";
        //     } else {
        //         orderBuildTime = " 6-8日";
        //     }
        // } else if (layer === 6) {
        //     orderBuildTime = " 6-8日";
        // }

        return (
            <Fragment>
                <div className="price-information-content web-view">
                    <div id="overlay" style={overlaystyle}>
                        <img className="loading-image-price" src={PriceLoadingImage} alt="Loading..."/>
                        {/*<div id="text">Overlay Text</div>*/}
                    </div>
                    {this.state.redirect ? <Redirect to="/cart"/> : null}
                    {this.state.redirectOnFail ? <Redirect to="/quotation/pcb"/> : ''}
                    <div className="price-information-div">
                        <div className="container-fluid">
                            <div className="quotation-page-titles">
                                <FormattedMessage id="app.price.info.title"
                                                  defaultMessage="PRICE INFORMATION"
                                                  description=""/>
                            </div>

                            <PricingPanel
                                initialFee={initialFee}
                                manufacturingCost={manufacturingCost}
                                // orderBuildTime={this.calTime}
                                orderBuildTime={this.state.calculatedBuildTime}
                                metalMaskCost={metalMaskCost}
                                discount={discount}
                                subtotal={subtotal}
                                tax={tax}
                                total={total}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            {/*<button onClick={this.addToCart} className="btn btn-success add-to-cart-btn">*/}
                            {/*<FormattedMessage id="app.price.info.add.to.cart"*/}
                            {/*defaultMessage="Add To Cart"*/}
                            {/*description=""/>*/}
                            {/*</button>*/}
                            <AddToCartToggle
                                selectedWidth={this.props.quotation.pcbParam.width}
                                selectedLength={this.props.quotation.pcbParam.length}
                                editMode={this.props.editMode}
                                addToCart={this.addToCart}
                                editCartItem={this.editCartItem}
                                gerberImageData={this.props.gerberImageData}
                                authenticated={this.props.authenticated}
                                errorMessage={this.props.errorMessage}
                            />
                        </div>
                    </div>
                </div>
                {/*//////////////////////////////////////////*/}
                <div className="row mobile-view pricing-fixed-z">
                    <div className="row">
                        <div className="price-loading-view-responsive-block" id="mobile-price-loading">
                            <img className="loading-image-price-responsive" src={PriceLoadingImage} alt="Loading..."/>
                        </div>
                        <div className="custom-col-6 responsive-quo-text">
                            合計 &nbsp; &#165; <NumberFormatter num={total}/>
                        </div>
                        <div className="custom-col-6-resp responsive-quo-text-add-to-cart">
                            <AddToCartToggle
                                selectedWidth={this.props.quotation.pcbParam.width}
                                selectedLength={this.props.quotation.pcbParam.length}
                                editMode={this.props.editMode}
                                addToCart={this.addToCart}
                                showGerberUploadModal={this.showGerberUploadModal}
                                editCartItem={this.editCartItem}
                                gerberImageData={this.props.gerberImageData}
                                authenticated={this.props.authenticated}
                                errorMessage={this.props.errorMessage}
                            />
                        </div>
                    </div>
                </div>


                {/*add to cart fail ------------------------------*/}
                <Modal dialogClassName="add-to-cart-fail-modal" show={this.state.addToCartFailShow}
                       onHide={this.addToCartFailedHandleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            カートに商品を追加する

                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-8 data-label">
                                    カートに商品を追加することはできません。もう一度やり直してください。
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right"
                                    onClick={this.addToCartFailedHandleClose}>
                                {/*<FormattedMessage id="app.admin-all-row.deactivate-no"*/}
                                {/*defaultMessage="No"*/}
                                {/*description=""/>*/}
                                Ok
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/*upload gerber file modal ------------------------------*/}
                <Modal dialogClassName="add-to-cart-fail-modal" show={this.state.showGerberUploadModal}
                       onHide={() => this.showGerberUploadModal(false)}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            カートに追加

                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-8 data-label quo-gerber-upload-request">
                                    ガーバーファイルをアップロードしてください。
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right"
                                    onClick={() => this.showGerberUploadModal(false)}>
                                閉じる
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/*pricing modal ------------------------------*/}
                <Modal dialogClassName="options-modal" show={this.props.showPricingModal}
                       onHide={this.props.closePricingModal}>
                    <Modal.Header closeButton>
                        <div className="quotation-page-titles">
                            <FormattedMessage id="app.price.info.title"
                                              defaultMessage="PRICE INFORMATION"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <PricingPanel
                            initialFee={initialFee}
                            manufacturingCost={manufacturingCost}
                            // orderBuildTime={orderBuildTime}
                            orderBuildTime={this.state.calculatedBuildTime}
                            metalMaskCost={metalMaskCost}
                            discount={discount}
                            subtotal={subtotal}
                            tax={tax}
                            total={total}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right"
                                    onClick={this.props.closePricingModal}>
                                閉じる
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </Fragment>

        )
    }
}

export default PriceInformation;



// WEBPACK FOOTER //
// ./src/components/Site/PriceInformation/PriceInformation.js